import { Function3 } from "lodash";

import { WarningMessages } from "globalConstants";
import { partnerTypes } from "mappers";

const {
	OverrideErrorMessage,
	IncorrectOverrideTotalAmount,
	DuplicateAgentErrorMessage,
} = WarningMessages;

export const isValidFormValues: Function3<
	{ [key: string]: any },
	Function,
	boolean,
	boolean
> = (values, setError, isOverride) => {
	let result: boolean = true;
	let residualSplitTotal: number = 0;
	let agentIds: Array<any> = [];
	let duplicatedAgentIds: Array<any> = [];

	agentIds?.push?.(values?.primarySplitInformation?.agent?.id);
	values?.secondarySplitInformation?.forEach?.(splitInfo => {
		if (agentIds?.indexOf?.(splitInfo?.agent?.id) === -1) {
			agentIds?.push?.(splitInfo?.agent?.id);
		} else if (duplicatedAgentIds?.indexOf?.(splitInfo?.agent?.id) === -1) {
			duplicatedAgentIds?.push?.(splitInfo?.agent?.id);
		}
	});

	values?.secondarySplitInformation?.forEach?.((splitInfo, index) => {
		if (duplicatedAgentIds?.indexOf?.(splitInfo?.agent?.id) !== -1) {
			setError(
				`secondarySplitInformation.${index}.agent`,
				{
					type: result ? "focus" : "manual",
					message: DuplicateAgentErrorMessage,
				},
				{ shouldFocus: result },
			);

			result = false;
		}
	});

	if (values?.secondarySplitInformation) {
		residualSplitTotal = parseFloat(
			values.primarySplitInformation.splitPercent,
		);
		values?.secondarySplitInformation?.forEach?.(element => {
			residualSplitTotal += parseFloat?.(element?.splitPercent);
		});
	}

	if (isOverride) {
		if (residualSplitTotal > 100) {
			if (
				values?.primarySplitInformation?.agent?.partnerType !==
				partnerTypes.BUSINESS_DEVELOPMENT
			) {
				setError(
					"primarySplitInformation.splitPercent",
					{
						type: "focus",
						message: OverrideErrorMessage,
					},
					{ shouldFocus: true },
				);

				result = false;
			}
			values?.secondarySplitInformation?.forEach?.((el, index) => {
				if (
					values?.secondarySplitInformation[index]?.agent
						?.partnerType !== partnerTypes.BUSINESS_DEVELOPMENT
				) {
					setError(
						`secondarySplitInformation.${index}.splitPercent`,
						{
							type: "manual",
							message: OverrideErrorMessage,
						},
					);

					result = false;
				}
			});
		}

		// eslint-disable-next-line eqeqeq
		if (residualSplitTotal != values?.totalRevenueShare) {
			setError(
				"primarySplitInformation.splitPercent",
				{
					type: "focus",
					message: IncorrectOverrideTotalAmount,
				},
				{ shouldFocus: true },
			);

			values?.secondarySplitInformation?.forEach?.((el, index) => {
				setError(`secondarySplitInformation.${index}.splitPercent`, {
					type: "manual",
					message: IncorrectOverrideTotalAmount,
				});
			});

			result = false;
		}
	}

	return result;
};
